import { useEffect } from "react";

function ChatBot() {
  useEffect(() => {
    const configScript = document.createElement("script");
    configScript.innerHTML = `
      window.chatbaseConfig = {
        chatbotId: "2fGN9foZdtfIeJunc0-5H"
      };
    `;
    document.body.appendChild(configScript);

    const script = document.createElement("script");
  
    script.src = "https://www.chatbase.co/chatbot-iframe";
    script.defer = true;
    script.setAttribute("chatbotId", "2fGN9foZdtfIeJunc0-5H");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(configScript);
      document.body.removeChild(script);
    };
  }, []);

  return null; // This component does not render any UI
}



  


export default ChatBot;
